import React from "react";

const FeedbacksIcon = ({
  color = "#2B2B2B",
  width = "100%",
  height = "100%"
}) => {

  return (
    <svg
      className="icon feedbacksIcon"
      width={width}
      height={height}
      viewBox="0 0 12 11"
      fill="none"
    >
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <path 
          d="M8.37830201,1.53680419 C8.97308349,1.53680419 9.45688477,2.01322021 9.45688477,2.59887085 L9.45688477,2.59887085 L9.45688477,9.36759034 C9.45688477,10.2676514 8.71151122,11 7.79513549,11 L7.79513549,11 L2.722406,11 C1.80609741,11 1.06072388,10.2676514 1.06072388,9.36759034 L1.06072388,9.36759034 L1.06072388,3.43642578 L0.0659973187,2.04665527 C-0.00436400938,1.94843139 -0.013830575,1.81918945 0.0413574219,1.71176758 C0.0966125531,1.6043457 0.20718995,1.53680419 0.327972408,1.53680419 L0.327972408,1.53680419 Z M9.23445435,-1.12443388e-12 C10.2111206,-1.12443388e-12 11.0057068,0.780419922 11.0057068,1.739563 L11.0057068,1.739563 L11.0057068,7.830719 C11.0057068,8.47760011 10.6206665,9.03780518 10.0640198,9.30179442 L10.0640198,9.30179442 L10.0640198,2.13829956 C10.0640198,1.48275756 9.52234497,0.949542241 8.85666504,0.949542241 L8.85666504,0.949542241 L2.76242065,0.949542241 C3.02614135,0.389605717 3.60306396,-1.12443388e-12 4.27122802,-1.12443388e-12 L4.27122802,-1.12443388e-12 Z M7.38632812,7.2341919 L2.67003784,7.2341919 C2.49212037,7.2341919 2.34777221,7.3784729 2.34777221,7.55645753 C2.34777221,7.73444213 2.49212037,7.87872315 2.67003784,7.87872315 L2.67003784,7.87872315 L7.38646239,7.87872315 C7.56437988,7.87872315 7.70859375,7.73444213 7.70859375,7.55645753 C7.70859375,7.3784729 7.56437988,7.2341919 7.38632812,7.2341919 L7.38632812,7.2341919 Z M6.87869263,5.9451294 L2.67003784,5.9451294 C2.49212037,5.9451294 2.34777221,6.0894104 2.34777221,6.26739503 C2.34777221,6.44537963 2.49212037,6.58966065 2.67003784,6.58966065 L2.67003784,6.58966065 L6.87869263,6.58966065 C7.05667724,6.58966065 7.20095826,6.44537963 7.20095826,6.26739503 C7.20095826,6.0894104 7.05667724,5.9451294 6.87869263,5.9451294 L6.87869263,5.9451294 Z M7.83165893,4.6560669 L2.67003784,4.6560669 C2.49212037,4.6560669 2.34777221,4.8003479 2.34777221,4.97833253 C2.34777221,5.15631713 2.49212037,5.30059815 2.67003784,5.30059815 L2.67003784,5.30059815 L7.83165893,5.30059815 C8.00964355,5.30059815 8.15392456,5.15631713 8.15392456,4.97833253 C8.15392456,4.8003479 8.00964355,4.6560669 7.83165893,4.6560669 L7.83165893,4.6560669 Z"
          id="feedbackIcon"
          fill={color}
          fillRule="nonzero"
        >
        </path>
      </g>
    </svg>
  );
};

export default FeedbacksIcon;
